import { updateUserSettings } from "../../api";
import { isLoggedIn } from "../../utils/isLoggedIn";

export const getStoredTheme = () => {
  try {
    const stored = localStorage.getItem("theme");
    if (stored === "dark" || stored === "light") return stored;

    const userRaw = localStorage.getItem("user");
    if (userRaw) {
      const user = JSON.parse(userRaw);
      if (user?.settings?.darkUIMode) return "dark";
    }
  } catch {
    // ignore
  }
  return "dark";
};

export const applyDocumentTheme = (theme) => {
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem("theme", theme);
};

export const persistThemePreference = (theme) => {
  applyDocumentTheme(theme);
  if (isLoggedIn()) {
    updateUserSettings({ darkUIMode: theme === "dark" });
  }
};
